import CIQClient, { HTTPClientResponse } from "services/ciq-client";

async function exportCustomReportAsCSV(
  reportId: string,
  projectToken: string,
  payload: {
    flat_layout: boolean;
    include_comments?: boolean;
  }
) {
  const response = await CIQClient.post({
    url: `/report-engine/custom-report/${reportId}/export`,
    data: payload,
    config: { headers: { Authorization: `Bearer ${projectToken}` } },
    showError: false
  });

  return response;
}

/** One in-flight report data fetch per request shape (survives Strict Mode remount). */
const inFlightCustomReportDataFetches = new Map<
  string,
  Promise<HTTPClientResponse>
>();

function getCustomReportData(
  reportId: string,
  projectToken: string,
  { include_comments: includeComments }: { include_comments?: boolean } = {}
): Promise<HTTPClientResponse> {
  let url = `/report-engine/custom-report/${reportId}/data`;
  if (includeComments) {
    url += "?include_comments=true";
  }

  const key = `${projectToken}|${url}`;
  let inFlight = inFlightCustomReportDataFetches.get(key);
  if (inFlight) {
    return inFlight;
  }

  inFlight = CIQClient.get({
    url,
    config: { headers: { Authorization: `Bearer ${projectToken}` } }
  }).finally(() => {
    if (inFlightCustomReportDataFetches.get(key) === inFlight) {
      inFlightCustomReportDataFetches.delete(key);
    }
  });
  inFlightCustomReportDataFetches.set(key, inFlight);
  return inFlight;
}

export { exportCustomReportAsCSV, getCustomReportData };
